import BaseRepository from '@/core/standard/BaseRepository';
import {AxiosInstance} from 'axios';

const queryResolver = (params: Record<string, string | number | boolean>): string => {

  return Object.entries(params).map(([key, value]) => `${key}=${value.toString()}`).join('&');
};

export class StockRepo extends BaseRepository {
  constructor(obj: AxiosInstance) {
    super(obj);
  }

  public generateFinalURL(id: string | number | undefined, url: string | undefined, version: string = this.version) {
    let finalURL = version ? `${version}/${this.collection}` : `${this.collection}`;
    if (id) {
      finalURL += `/${id}`;
      finalURL += url ? `${url}/` : '';
    } else {
      if (url) {
        finalURL += `${url}`;
      }
    }
    this.provider.defaults.paramsSerializer = this.param2query
    return finalURL;
  }

  public param2query(params: Record<string, string | number | boolean>): string {

    const base64 = btoa(JSON.stringify(params));
    return `q=${base64}`;
    // return Object.entries(params).map(([key, value]) => `${key}=${value.toString()}`).join('&');
  }

}
